export const windDirectionNames = {
  1: '南南西',
  2: '南西',
  3: '西南西',
  4: '西',
  5: '西北西',
  6: '北西',
  7: '北北西',
  8: '北',
  9: '北北東',
  10: '北東',
  11: '東北東',
  12: '東',
  13: '東南東',
  14: '南東',
  15: '南南東',
  16: '南'
}

export const prefLatlon = {
  okinawa: { lat: 26.451233957189558, lon: 127.711575038793, zoom: 8 },
  akita: { lat: 39.673113154156, lon: 140.424727730177, zoom: 7.5 },
  tokyo: { lat: 35.7344638104283, lon: 139.462000859646, zoom: 9 },
  aomori: { lat: 40.8610612290248, lon: 140.769586064051, zoom: 7.5 },
  tokushima: { lat: 33.88510820795487, lon: 134.237709983014, zoom: 8.5 },
  fukuoka: { lat: 33.49173714566287, lon: 130.589180583845, zoom: 8 },
  aichi: { lat: 34.9761776192127, lon: 137.24146046453, zoom: 8.3 },
  niigata: { lat: 37.6074781364233, lon: 138.711600877861, zoom: 7.3 },
  douhoku: { lat: 44.172548452862145, lon: 142.45844631065233, zoom: 7 },
  yamagata: { lat: 38.434844543198, lon: 139.956629125333, zoom: 7.6 },
  shizuoka: { lat: 35.09718990337382, lon: 138.316949122248, zoom: 8 },
  toyama: { lat: 36.62085772445607, lon: 137.275348961663, zoom: 8.5 },
  nagasaki: { lat: 33.15881928973694, lon: 129.541889801944, zoom: 7.8 },
  yamanashi: { lat: 35.581437822056, lon: 138.639016782313, zoom: 8.5 },
  kagoshima: { lat: 31.587743795271308, lon: 130.550801257681, zoom: 7.8 },
  saga: { lat: 33.2472170142168, lon: 130.11985927014, zoom: 8.8 },
  saitama: { lat: 36.02297553066458, lon: 139.306068156507, zoom: 8.8 },
  mie: { lat: 34.46059739791234, lon: 136.293857178562, zoom: 7.5 },
  ibaraki: { lat: 36.39578745547229, lon: 140.31227051107157, zoom: 7.9 },
  kagawa: { lat: 34.2315893051082, lon: 133.98971080838, zoom: 9 },
  kyoto: { lat: 35.23487598992402, lon: 135.433821596397, zoom: 8 },
  kumamoto: { lat: 32.61890191218676, lon: 130.627404732995, zoom: 8 },
  miyagi: { lat: 38.4181431727088, lon: 140.966669736523, zoom: 8 },
  ehime: { lat: 33.5812385380167, lon: 132.882224714321, zoom: 8 },
  hyogo: { lat: 34.94811661740469, lon: 134.771237390772, zoom: 7.5 },
  doutou: { lat: 43.2719640734857, lon: 144.107562193347, zoom: 7.2 },
  douou: { lat: 43.162028391494, lon: 141.104109045381, zoom: 7.5 },
  nara: { lat: 34.3127770014575, lon: 135.840452961458, zoom: 8.2 },
  nagano: { lat: 36.0009750552773, lon: 138.02821901125, zoom: 7.5 },
  oita: { lat: 33.22178541415845, lon: 131.415047457835, zoom: 8.2 },
  ishikawa: { lat: 36.7605877427748, lon: 136.753775535887, zoom: 7.8 },
  miyazaki: { lat: 32.136227241909964, lon: 131.236545527876, zoom: 7.5 },
  gunma: { lat: 36.48010379382, lon: 139.003400288112, zoom: 8 },
  kanagawa: { lat: 35.40905786553037, lon: 139.440604757217, zoom: 8.8 },
  wakayama: { lat: 33.9261275773755, lon: 135.486487819343, zoom: 8.2 },
  shiga: { lat: 35.2365840809182, lon: 136.135462157876, zoom: 8.2 },
  fukui: { lat: 35.8304942067212, lon: 136.108300855309, zoom: 8 },
  fukushima: { lat: 37.4108893086075, lon: 140.109982140618, zoom: 7.8 },
  yamaguchi: { lat: 34.219170812631674, lon: 131.598268553814, zoom: 8.2 },
  okayama: { lat: 34.88177815541859, lon: 133.863987702736, zoom: 8 },
  gifu: { lat: 35.7803043337995, lon: 137.010560630143, zoom: 7.8 },
  hiroshima: { lat: 34.58303089008905, lon: 132.774094943809, zoom: 8 },
  kouchi: { lat: 33.3275195941585, lon: 133.353411403605, zoom: 8 },
  osaka: { lat: 34.664207853662205, lon: 135.355252904013, zoom: 8.4 },
  iwate: { lat: 39.5821406771585, lon: 141.40440855586, zoom: 7.5 },
  shimane: { lat: 34.95659880519963, lon: 132.44636663617, zoom: 7.6 },
  chiba: { lat: 35.41506840278318, lon: 140.198980407397, zoom: 8 },
  dounan: { lat: 42.4382391516222, lon: 141.339522705042, zoom: 7 },
  tottori: { lat: 35.3391494011555, lon: 133.797202911825, zoom: 8.5 },
  tochigi: { lat: 36.68104945024737, lon: 139.795062721959, zoom: 8 }
}

export const areaToPrefTable = [
  {
    name: '北海道',
    key: 'hokkaido',
    pref_list: [
      { name: '道央', key: 'douou' },
      { name: '道南', key: 'dounan' },
      { name: '道北', key: 'douhoku' },
      { name: '道東', key: 'doutou' }
    ]
  },
  {
    name: '東北',
    key: 'tohoku',
    pref_list: [
      { name: '青森', key: 'aomori' },
      { name: '岩手', key: 'iwate' },
      { name: '秋田', key: 'akita' },
      { name: '宮城', key: 'miyagi' },
      { name: '山形', key: 'yamagata' },
      { name: '福島', key: 'fukushima' }
    ]
  },
  {
    name: '関東',
    key: 'kanto',
    pref_list: [
      { name: '東京', key: 'tokyo' },
      { name: '神奈川', key: 'kanagawa' },
      { name: '埼玉', key: 'saitama' },
      { name: '千葉', key: 'chiba' },
      { name: '茨城', key: 'ibaraki' },
      { name: '栃木', key: 'tochigi' },
      { name: '群馬', key: 'gunma' }
    ]
  },
  {
    name: '中部',
    key: 'chubu',
    pref_list: [
      { name: '静岡', key: 'shizuoka' },
      { name: '愛知', key: 'aichi' },
      { name: '岐阜', key: 'gifu' },
      { name: '山梨', key: 'yamanashi' },
      { name: '長野', key: 'nagano' },
      { name: '新潟', key: 'niigata' },
      { name: '富山', key: 'toyama' },
      { name: '石川', key: 'ishikawa' },
      { name: '福井', key: 'fukui' },
      { name: '三重', key: 'mie' }
    ]
  },
  {
    name: '近畿',
    key: 'kinki',
    pref_list: [
      { name: '大阪', key: 'osaka' },
      { name: '兵庫', key: 'hyogo' },
      { name: '京都', key: 'kyoto' },
      { name: '滋賀', key: 'shiga' },
      { name: '奈良', key: 'nara' },
      { name: '和歌山', key: 'wakayama' }
    ]
  },
  {
    name: '中国',
    key: 'chugoku',
    pref_list: [
      { name: '広島', key: 'hiroshima' },
      { name: '岡山', key: 'okayama' },
      { name: '山口', key: 'yamaguchi' },
      { name: '島根', key: 'shimane' },
      { name: '鳥取', key: 'tottori' }
    ]
  },
  {
    name: '四国',
    key: 'shikoku',
    pref_list: [
      { name: '香川', key: 'kagawa' },
      { name: '徳島', key: 'tokushima' },
      { name: '愛媛', key: 'ehime' },
      { name: '高知', key: 'kouchi' }
    ]
  },
  {
    name: '九州',
    key: 'kyushu',
    pref_list: [
      { name: '福岡', key: 'fukuoka' },
      { name: '佐賀', key: 'saga' },
      { name: '長崎', key: 'nagasaki' },
      { name: '大分', key: 'oita' },
      { name: '熊本', key: 'kumamoto' },
      { name: '宮崎', key: 'miyazaki' },
      { name: '鹿児島', key: 'kagoshima' }
    ]
  },
  {
    name: '沖縄',
    key: 'okinawa',
    pref_list: []
  }
]

export const metaConfig = {
  top: {
    title: 'ゴルフ場の天気｜全国約2,400ヶ所',
    description1: '全国各地2,400ヶ所の',
    description2: 'ベストスコア更新など用途に合わせてお役立てください。',
    keyword: 'ゴルフ場,天気,ウェザーニュース'
  },
  area: {
    title: 'のゴルフ場の天気｜全国約2,400ヶ所',
    description1: 'の',
    description2: 'ゴルフ場の天気は【予報精度No.1】ウェザーニュースでチェック。',
    keyword: ',ゴルフ場,天気'
  },
  pref: {
    title: 'のゴルフ場の天気｜全国約2,400ヶ所',
    description1: 'の',
    description2: 'ゴルフ場の天気は【予報精度No.1】ウェザーニュースでチェック。',
    keyword: ',ゴルフ場,天気'
  },
  point: {
    title: 'の天気【予報精度No.1】',
    description1: 'のゴルフ場｜ピンポイント天気',
    description2: 'ベストスコア更新など用途に合わせてお役立てください。',
    keyword: ',天気,ウェザーニュース'
  },
  ranking: {
    title: 'のゴルフ場の人気ランキング｜全国約2,400ヶ所',
    description1: '【ゴルフ場人気ランキング】ウェザーニュースのゴルフ場の天気でよく見られている',
    description2: 'のゴルフ場を元にランキングにしています。今、注目されているゴルフ場をご確認いただけます。ゴルフ場の天気は【予報精度No.1】ウェザーニュースでチェック。',
    keyword: ',ゴルフ場,ランキング'
  }
}
